// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"NqaC3H1gV2_4qCdngciXf"};